import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { ONLINE_SALES_RETURN_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const OnlineSalesReturnApi = createApi({
  reducerPath: "OnlineSalesReturn",
  baseQuery,
  tagTypes: ["OnlineSalesReturn"],
  endpoints: (builder) => ({
    getOnlineSalesReturn: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: ONLINE_SALES_RETURN_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: ONLINE_SALES_RETURN_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["OnlineSalesReturn"],
    }),
    getOnlineSalesReturnById: builder.query({
      query: ({ id }) => {
        return {
          url: `${ONLINE_SALES_RETURN_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["OnlineSalesReturn"],
    }),
    addOnlineSalesReturn: builder.mutation({
      query: (payload) => ({
        url: ONLINE_SALES_RETURN_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["OnlineSalesReturn"],
    }),
    updateOnlineSalesReturn: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${ONLINE_SALES_RETURN_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["OnlineSalesReturn"],
    }),
    deleteOnlineSalesReturn: builder.mutation({
      query: (id) => ({
        url: `${ONLINE_SALES_RETURN_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["OnlineSalesReturn"],
    }),
  }),
});

export const {
  useGetOnlineSalesReturnQuery,
  useGetOnlineSalesReturnByIdQuery,
  useAddOnlineSalesReturnMutation,
  useUpdateOnlineSalesReturnMutation,
  useDeleteOnlineSalesReturnMutation,
} = OnlineSalesReturnApi;

export default OnlineSalesReturnApi;
